export const CHART_PADDING = 20
